import { useState } from 'react';
import { verificarTotp } from '../supabase';
import { MarcoAcceso } from './AccesoMarco';
import { traducirErrorAuth } from '../utils/claveAuth';

// ═══════════════════════════════════════════════════════════════════════════════
// CÓDIGO DE VERIFICACIÓN (Lote B2, nov-2026) — segundo paso al entrar.
// App.js lo muestra cuando la sesión es aal1 y el usuario tiene un factor TOTP
// verificado (nivelMfa().siguiente === 'aal2'). Nada del portal carga antes:
// ni perfil ni datos. Al acertar, Auth emite MFA_CHALLENGE_VERIFIED, la sesión
// pasa a aal2 y App.js deja pasar. Si no se completa en 15 min, Auth termina la
// sesión (panel: «Limit duration of AAL1 sessions»).
// ═══════════════════════════════════════════════════════════════════════════════

export default function MfaCodigo({ factorId, onSalir, onListo }) {
  const [codigo, setCodigo] = useState('');
  const [err,    setErr]    = useState('');
  const [busy,   setBusy]   = useState(false);

  const enviar = async () => {
    setErr('');
    const limpio = codigo.replace(/\D/g, '');
    if (limpio.length !== 6) { setErr('El código tiene 6 números. Revisa tu app autenticadora.'); return; }
    setBusy(true);
    try {
      const { error } = await verificarTotp(factorId, limpio);
      if (error) {
        setErr(traducirErrorAuth(error, 'No pudimos verificar el código. Intenta de nuevo.'));
        setCodigo('');
        setBusy(false);
        return;
      }
      onListo?.();
    } catch {
      setErr('Error de conexión. Intenta de nuevo.');
      setBusy(false);
    }
  };

  return (
    <MarcoAcceso>
      <h2 className="lg-h">Verificación en dos pasos</h2>
      <p className="lg-sub">
        Abre tu app autenticadora y escribe el código de 6 números de <b>Innovalab</b>.
      </p>

      <div className="lg-campo">
        <label className="lg-label" htmlFor="mfa-codigo">Código</label>
        <input id="mfa-codigo" className="lg-input" inputMode="numeric" autoComplete="one-time-code"
          maxLength={7} value={codigo} autoFocus placeholder="000000"
          onChange={e => { setCodigo(e.target.value.replace(/[^\d ]/g, '')); setErr(''); }}
          onKeyDown={e => { if (e.key === 'Enter' && !busy) enviar(); }}
          style={{ letterSpacing: 6, fontSize: 20, textAlign: 'center' }} />
      </div>

      {err && <div className="lg-msg error">{err}</div>}

      <button className="lg-btn" onClick={enviar} disabled={busy}>
        {busy ? 'Verificando…' : 'Verificar y entrar'}
      </button>

      <div className="lg-centro">
        <button className="lg-link" onClick={onSalir} disabled={busy}>Cerrar sesión</button>
      </div>
      <p className="lg-sub" style={{ fontSize: 12, marginTop: 14 }}>
        ¿Perdiste el teléfono? Pide a un administrador que quite tu verificación en dos pasos.
      </p>
    </MarcoAcceso>
  );
}
